import axios from "../../utils/axios";
import type {
    AcknowledgementRecipientDTO,
    RiskAssessmentAcknowledgementDetailsDTO,
    RiskAssessmentAcknowledgementFileDTO,
} from "../types/riskAssessmentAcknowledgement";

// SafetyNest's own acknowledge endpoints. The MyWorkNest ones still serve links from
// emails sent before this shipped, so both exist for now.
const apiUrl = `${process.env.REACT_APP_HS_API_URL}/RiskAssessmentAcknowledgement`;

const getDetailsByReference = ({ reference }: { reference: string }) =>
    axios.get<RiskAssessmentAcknowledgementDetailsDTO>(`${apiUrl}/Details/${reference}`);

const verify = ({ reference, emailAddress }: { reference: string; emailAddress: string }) =>
    axios.get<RiskAssessmentAcknowledgementFileDTO>(`${apiUrl}/Verify/${reference}?emailAddress=${encodeURIComponent(emailAddress)}`);

const acknowledge = ({ reference, emailAddress }: { reference: string; emailAddress: string }) =>
    axios.post<AcknowledgementRecipientDTO>(`${apiUrl}/Acknowledge/${reference}?emailAddress=${encodeURIComponent(emailAddress)}`);

const riskAssessmentAcknowledgementService = {
    getDetailsByReference,
    verify,
    acknowledge,
};

export default riskAssessmentAcknowledgementService;
